// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8067) return "assets/js/vendor/8067.js";
	if (chunkId === 7309) return "assets/js/vendor/7309.js";
	// return url for filenames based on template
	return undefined;
};